import { FC, useState } from "react";

import {
	EnhancedDatePicker,
	EnhancedIOSSwitchRHFWithLabel,
	FieldLayout,
	ITest,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextField,
	RHookFormTextFieldWithLabel,
	SinNumber,
	SinNumberRHF,
} from "@websential/cosmic-v20";

import { DatePicker, DesktopDatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Box, Stack, TextField } from "@mui/material";

import { Calendar } from "primereact/calendar";
import { useController, useFormContext } from "react-hook-form";
import { FieldWrapper } from "../../../FieldWrapper/FieldWrapper";

interface IEmployeeInfoSetupFieldsPanel extends ITest {
	onDateOfBirthChangeHandler: (selectedDate: any) => void;
}

export const EmployeeInfoSetupFieldsPanel: FC<
	IEmployeeInfoSetupFieldsPanel
> = ({ onDateOfBirthChangeHandler, testId }) => {
	return (
		<>
			{/* <FieldWrapper>
				<EnhancedIOSSwitchRHFWithLabel
					// name="reflectInEmployee"
					name="reflectMasterData"
					checked={false}
					testId="reflectInEmployee"
					label="Reflect in Employee"
					labelPosition={LabelPosition.Top}
				/>
			</FieldWrapper> */}
			<RHookFormTextFieldWithLabel
				label="Employee Code"
				id="employeeCode"
				testId={`${testId}-employee-code`}
				labelPosition={LabelPosition.Top}
			/>
			<SinNumberRHF
				id="socialInsuranceNumber"
				label="Social Insurance"
				required={true}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
				testId="socialInsuranceNumber"
			/>
			<RHookFormTextFieldWithLabel
				label="First Name"
				id="firstName"
				testId={`${testId}-first-name`}
				labelPosition={LabelPosition.Top}
				required
			/>
			<RHookFormMaskedTextFieldWithLabel
				label="Initials"
				id="initials"
				testId={`${testId}-initials`}
				labelPosition={LabelPosition.Top}
				inputMaskPattern={"a"}
			/>
			<RHookFormTextFieldWithLabel
				label="Last Name"
				id="lastName"
				testId={`${testId}-last-name`}
				labelPosition={LabelPosition.Top}
				required
			/>
			<RHookFormDatePicker
				name="dateOfBirth"
				testId="date-of-birth"
				label="Date of Birth"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				// required
				labelColumns={4}
				fieldColumns={8}
				// onDateSelectionChangeHandler={onDateOfBirthChangeHandler}
			/>
		</>
	);
};
